// FOR PARENT
const currentLocations = location.href;
const menuItems = document.querySelectorAll('.custom-menu-class');
const menuLengths = menuItems.length;

for(let i = 0; i<menuLengths; i++)
{
	if(menuItems[i].href == currentLocations)
{
  console.log("link",currentLocations)
menuItems[i].classList.add("menu-color-active");
}
 
  
} 

function activemenu(){
const currentLocation = location.href;
const menuItem = document.querySelectorAll('.custom-menu-class');
const menuLength= menuItem.length;

for(let i = 0; i<menuLength; i++)
{
	if(menuItem[i].href == currentLocation)
{
  console.log("link",currentLocation)
menuItem[i].classList.add("menu-color-active");
}
 
  
} 
}
// FOR PARENT

// FOR CHILD

const currentLocationss = location.href;
const menuItemss = document.querySelectorAll('.mob-custom-menu-class');
const menuLengthss = menuItemss.length;

for(let i = 0; i<menuLengthss; i++)
{
	if(menuItemss[i].href == currentLocationss)
{
  console.log("link",currentLocationss)
menuItemss[i].classList.add("menu-color-active");
   // menuItemss[i].parentElement.classList.add('menu-color-active');
}
 
  
} 

function activemenumob(){
const currentLocationsss = location.href;
const menuItemsss = document.querySelectorAll('.mob-custom-menu-class');
const menuLengthsss = menuItemsss.length;

for(let i = 0; i<menuLengthsss; i++)
{
	if(menuItemsss[i].href == currentLocationsss)
{
  console.log("link",currentLocationsss)
menuItemsss[i].classList.add("menu-color-active");
  // menuItemsss[i].parentElement.classList.add('menu-color-active');
}
 
  
} 
}
// FOR CHILD


console.log("I am running")

//ANIMATION JS
$(document).ready(function() {
  setInterval(function() {
      $(".anim-btn-class").removeClass("anim-default-class");
    }, 4000)
  
  setInterval(function() {

    $(".anim-btn-class").addClass("anim-btn-classs");//adds the class

    setTimeout(function() {//waits 6 seconds to remove the class
      $(".anim-btn-class").removeClass("anim-btn-classs");
    }, 6000);

  }, 60000)//repeats the process every 10 seconds
});


$('#surittt').on('keypress',function(e) {
  if(e.which == 13) {
    $('#surittt').trigger('mouseover');
  }
});